import { useAuthMember } from '@tribeplatform/react-sdk/hooks'

import { useI18n } from '../../i18n/providers/I18nProvider.js'
import { CommandBarHookResult, emptyCommandBarResult } from '../types.js'

export const useCommandBarAdminSettings: CommandBarHookResult = () => {
  const { $t } = useI18n()
  const { isInitialLoading, isAdmin } = useAuthMember()

  const categoryTexts = {
    managePeople: $t({
      id: 'CommandBar.AdminSettings.ManagePeople',
      defaultMessage: 'Manage people',
    }),
    manageContent: $t({
      id: 'CommandBar.AdminSettings.ManageContent',
      defaultMessage: 'Manage content',
    }),
    administration: $t({
      id: 'Generics.Administration',
      defaultMessage: 'Administration',
    }),
    customize: $t({
      id: 'Generics.Customize',
      defaultMessage: 'Customize',
    }),
    analytics: $t({
      id: 'Generics.Analytics',
      defaultMessage: 'Analytics',
    }),
    apps: $t({
      id: 'Generics.Apps',
      defaultMessage: 'Apps',
    }),
  } as const

  if (!isAdmin) {
    return emptyCommandBarResult
  }
  return {
    isLoading: isInitialLoading,
    actions: [
      {
        name: $t({
          id: 'CommandBar.AdminSettings.ManageMembers',
          defaultMessage: 'Manage {MEMBERS}',
        }),
        icon: 'member',
        url: '/manage/people/members',
        category: categoryTexts.managePeople,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.ManageStaff',
          defaultMessage: 'Manage staff',
        }),
        icon: 'members',
        url: '/manage/people/staff',
        category: categoryTexts.managePeople,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.ManageInvitations',
          defaultMessage: 'Manage invitations',
        }),
        icon: 'inbox',
        url: '/manage/people/invitations',
        category: categoryTexts.managePeople,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.ManageProfileFeields',
          defaultMessage: 'Manage profile fields',
        }),
        icon: 'members',
        url: '/manage/people/fields',
        category: categoryTexts.managePeople,
      },
      {
        name: $t({
          id: 'Generics.ManageBadges',
          defaultMessage: 'Manage badges',
        }),
        icon: 'badge-check',
        url: '/manage/people/badges',
        category: categoryTexts.managePeople,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.ManagePosts',
          defaultMessage: 'Manage posts',
        }),
        icon: 'post',
        url: '/manage/content',
        category: categoryTexts.manageContent,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.ManageSpaces',
          defaultMessage: 'Manage {SPACES}',
        }),
        icon: 'grid',
        url: '/manage/content/spaces',
        category: categoryTexts.manageContent,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.ManageTags',
          defaultMessage: 'Manage {TAGS}',
        }),
        icon: 'tag',
        url: '/manage/content/tags',
        category: categoryTexts.manageContent,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.ManageCMSModels',
          defaultMessage: 'Manage CMS models',
        }),
        icon: 'post-type',
        url: '/manage/content/cms',
        category: categoryTexts.manageContent,
      },
      {
        name: $t({
          id: 'Generics.CustomizeSpaces',
          defaultMessage: 'Manage customize {SPACES}',
        }),
        icon: 'customizer',
        url: '/manage/customizer/spaces',
        category: categoryTexts.customize,
      },
      {
        name: $t({
          id: 'Generics.CustomizeThemeColors',
          defaultMessage: 'Customize theme colors',
        }),
        icon: 'appearance',
        url: '/manage/appearance/colors',
        category: categoryTexts.customize,
      },
      {
        name: $t({
          id: 'Generics.CustomizeCommunityNavigation',
          defaultMessage: 'Customize {COMMUNITY} navigation',
        }),
        icon: 'template',
        url: '/manage/customizer/navigation',
        category: categoryTexts.customize,
      },
      {
        name: $t({
          id: 'Generics.CustomizeThemeTypography',
          defaultMessage: 'Customize theme typography',
        }),
        icon: 'font-size',
        url: '/manage/customizer/typography',
        category: categoryTexts.customize,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.CommunitySettings',
          defaultMessage: '{COMMUNITY} settings',
        }),
        icon: 'settings',
        url: '/manage/settings/network',
        category: categoryTexts.administration,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.CommunityModerationSettings',
          defaultMessage: '{COMMUNITY} moderation settings',
        }),
        icon: 'moderation',
        url: '/manage/settings/moderation',
        category: categoryTexts.administration,
      },
      {
        name: $t({
          id: 'Generics.Billing',
          defaultMessage: 'Billing',
        }),
        icon: 'credit-card',
        url: '/manage/billing',
        category: categoryTexts.administration,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.CommunityAnalytics',
          defaultMessage: '{COMMUNITY} analytics',
        }),
        icon: 'analytics',
        url: '/manage/reports/analytics',
        category: categoryTexts.analytics,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.CommunityAuditLogs',
          defaultMessage: '{COMMUNITY} audit logs',
        }),
        icon: 'audit-log',
        url: '/manage/reports/audit-logs',
        category: categoryTexts.analytics,
      },
      {
        name: $t({
          id: 'CommandBar.AdminSettings.InstallApps',
          defaultMessage: 'Install apps',
        }),
        icon: 'apps',
        url: '/manage/apps',
        category: categoryTexts.apps,
      },
    ],
  }
}
